import React, { useCallback, useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import './style.less';

const maskStyle = { position: 'absolute' } as const;

export const InlineModal: React.FC<ModalProps> = props => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  const getContainer = useCallback(() => {
    return (container?.offsetParent as HTMLElement) || document.body;
  }, [container]);

  return (
    <div ref={setContainer}>
      {container && (
        <Modal
          {...props}
          centered
          getContainer={getContainer}
          maskStyle={maskStyle}
          wrapClassName="InlineModal__wrap"
        />
      )}
    </div>
  );
};
